import { createContext, useContext, useEffect, useState } from "react"
import Portfolio from "../models/Portfolio"
import PortAccount from "../models/PortAccount"
import { useAuth } from "../gui/Login/AuthProvider"

type TPortfolioConext = {
    portfolio:Portfolio
    ready:boolean
    error?:any
}
const PortfolioContext = createContext<TPortfolioConext>({} as any)
const usePortfolio = () => useContext(PortfolioContext)

export default usePortfolio

export function PortfolioProvider(props:{children:any}) {
    const {isLoggedIn} = useAuth()
    const [portfolio,setPortfolio] = useState<Portfolio>(PortAccount.i.portfolio)
    const [error,setError] = useState<any>()
    const [ready,setReady] = useState<boolean>(false)

    const _setPortfolio = (portfolio:Portfolio) => {
        setPortfolio(portfolio)
        setReady(true)
    }

    const getPortfolio = async () => {
        try { 
            setError(null)
            await PortAccount.i.me() 
        }
        catch(e){
            setError(e)
        }
    }
    
    useEffect(() => {
        if (!isLoggedIn) setReady(false)
        else getPortfolio()
    }, [isLoggedIn])

    useEffect(() => {
        PortAccount.i.on("refresh", _setPortfolio)
        return () => {PortAccount.i.removeListener("refresh", _setPortfolio)}
    }, [])  
    return <PortfolioContext.Provider value={{portfolio,ready,error}}>
        {props.children}
    </PortfolioContext.Provider>
}
